import { EmptyState } from '@commenda/kakashi';

export function MissingRegistrationState({
  jurisdictionName,
  onAddRegistration,
  onCalculateAnyway,
}: {
  jurisdictionName: string;
  onAddRegistration?: () => void;
  onCalculateAnyway?: () => void;
}) {
  return (
    <EmptyState
      heading={`You’re not registered in ${jurisdictionName}`}
      description={`You can still calculate tax to see the rate. In most cases, you need a registration before you collect tax in ${jurisdictionName}.`}
      primaryAction={
        onAddRegistration
          ? {
              label: 'Add registration',
              onClick: onAddRegistration,
              variant: 'primary',
            }
          : undefined
      }
      secondaryAction={
        onCalculateAnyway
          ? {
              label: 'Calculate anyway',
              onClick: onCalculateAnyway,
              variant: 'secondary',
            }
          : undefined
      }
    />
  );
}
